import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {AppStateService} from "../providers/app-state.service";
import {environment} from "../../environments/environment";
import {WellnessPlanService} from "../providers/wellness-plan.service";
import {WellnessPlanDgSearchResults} from "../models/datagrid-search-results/wellness-plan.dg-search-results.model";

@Injectable()
export class WellnessPlansResolve implements Resolve<WellnessPlanDgSearchResults> {
  constructor(private wellnessPlanService: WellnessPlanService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<WellnessPlanDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.wellnessPlanService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created', false).pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
